// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"_1H-WP","downloadIcon_arrow":"_2EaLw","downloadIcon_line":"pUVF0","downloadIconAnimation":"_3m8Qp"};